<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol :size="12">
        <MetaSection>
          <div class="text-right">
            <!-- <argon-button :to="{ name: 'Create Unit Kerja' }" :isRouteLink="true">Buat Baru</argon-button> -->
          </div>
        </MetaSection>
      </GridCol>
      <GridCol :size="12">
        <CardComponent :useHeader="true">
          <!-- <template v-slot:header-action>
            <GridRow class="w-100">
              <GridCol :size="6">
                <div class="d-flex align-items-center justify-content-between gap-2">
                  <InputGroup class="w-100">
                    <template v-slot:prepend>
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </template>
                    <input v-model="params.keyword" @keyup="getData(params.keyword)" type="text" class="form-control"
                      placeholder="Cari nama unit kerja...">
                  </InputGroup>

                  <FormGroup class="m-0 w-100">
                    <select-form @change="getData()" name="status" id="status" v-model="params.status" placeholder="Semua Status" :options="[{text: 'Aktif', value: 'active'}, {text: 'Non Aktif', value: 'inactive'}]" />
                  </FormGroup>
                </div>
              </GridCol>
            </GridRow>
          </template> -->

            <!-- eslint-disable-next-line vue/no-deprecated-slot-scope-attribute vue/no-unused-vars -->
                <!-- <b v-if="data.children && data.children.length" @click="store.toggleOpen(data)"> -->
          <!-- <DraggableTree :data="data" draggable crossDraggableTree>
            <div slot-scope="{data, store, vm}">
              <template v-if="!data.isDragPlaceHolder">
                <b v-if="data.children && data.children.length">
                  {{ data.open ? '-' : '+' }}&nbsp;
                </b>
                <span>{{data.text}}</span>
              </template>
            </div>
          </DraggableTree> -->

          <!-- <Tree :data="tree1data" draggable cross-tree>
            div()
            <div slot-scope="{data, store}"></div>
          </Tree>

          Tree(:data="tree1data" draggable cross-tree)
            div(slot-scope="{data, store}")
              template(v-if="!data.isDragPlaceHolder")
                b(v-if="data.children && data.children.length" @click="store.toggleOpen(data)") {{data.open ? '-' : '+'}}&nbsp;
                span {{data.text}} -->
          
        </CardComponent>
      </GridCol>
    </GridRow>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent.vue';
import UnitKerjaApi from '@/repository/api/UnitKerjaApi';
import MetaSection from '@/components/MetaSection.vue';
import GridRow from '@/components/grid/GridRow.vue';
import GridCol from '@/components/grid/GridCol.vue';
// import InputGroup from '@/components/InputGroup.vue';
// import SelectForm from '@/components/SelectForm.vue';
// import { DraggableTree } from "vue-draggable-nested-tree";
// import { vueDraggableNestedTree } from "vue-draggable-nested-tree";
// Tree: vueDraggableNestedTree.DraggableTree

export default {
  name: "tables",
  components: {
    CardComponent,
    MetaSection,
    GridRow,
    GridCol,
    // InputGroup,
    // SelectForm,
    // DraggableTree,
    // Tree: vueDraggableNestedTree.DraggableTree,
  },
  data() {
    return {
      timer: undefined,
      data: [
        { text: "node 1" },
        { text: "node 2" },
        { text: "node 3 undraggable", draggable: false },
        { text: "node 4" },
        { text: "node 4 undroppable", droppable: false },
        {
          text: "node 5",
          children: [
            { text: "node 1" },
            { text: "node 2", children: [{ text: "node 3" }, { text: "node 4" }] },
            {
              text: "node 2 undroppable",
              droppable: false,
              children: [{ text: "node 3" }, { text: "node 4" }],
            },
            {
              text: "node 2",
              children: [
                { text: "node 3" },
                { text: "node 4 undroppable", droppable: false },
              ],
            },
            { text: "node 3" },
            { text: "node 4" },
            { text: "node 3" },
            { text: "node 4" },
            { text: "node 3" },
            { text: "node 4" },
            { text: "node 3" },
            { text: "node 4" },
          ],
        },
      ],
      tree1data: [
        {text: 'node 1'},
        {text: 'node 2'},
        {text: 'node 3 undraggable', draggable: false},
        {text: 'node 4'},
        {text: 'node 4 undroppable', droppable: false},
        {text: 'node 5', children: [
          {text: 'node 1'},
          {text: 'node 2', children: [
            {text: 'node 3'},
            {text: 'node 4'},
          ]},
          {text: 'node 2 undroppable', droppable: false, children: [
            {text: 'node 3'},
            {text: 'node 4'},
          ]},
          {text: 'node 2', children: [
            {text: 'node 3'},
            {text: 'node 4 undroppable', droppable: false},
          ]},
          {text: 'node 3'},
          {text: 'node 4'},
          {text: 'node 3'},
          {text: 'node 4'},
          {text: 'node 3'},
          {text: 'node 4'},
          {text: 'node 3'},
          {text: 'node 4'},
        ]},
      ],
      params: {
        limit: "",
        status: "",
        keyword: "",
        page: 1,
      },
      metaData: {},
    };
  },
  async mounted() {
    // await this.getData();
  },
  watch: {
    'params.limit': {
      handler: async function () {
        this.params.page = 1
        await this.getData();
      },
      deep: false,
    },
    'params.page': {
      handler: async function (newVal, oldVal) {
        if (newVal < 1) {
          this.params.page = oldVal
        }
        else {
          // await this.getJabatan();
          await this.getData();
        }
      },
      deep: false,
    },
  },
  methods: {
    changeLimit(limit) {
      this.params.limit = limit
    },
    changePage(page) {
      this.params.page = page
    },
    async getData(keyword = "") {
      clearTimeout(this.timer)
      if (keyword.length <= 0) {
        await this.getDataAll();
      }
      else if (keyword.length >= 2) {
        this.timer = setTimeout(async () => {
          await this.getDataAll()
        }, 1500)
      }
    },
    async getDataAll() {
      this.$store.state.loading = true;
      let params = {}
      Object.keys(this.params).forEach(key => {
        if (!(this.params[key] === undefined || this.params[key] === null || this.params[key] === "")) {
          params[key] = JSON.parse(JSON.stringify(this.params[key]))
        }
      });
      await UnitKerjaApi.getbyparam(params).then((response) => {
        this.data = response.data;
        this.metaData = {
          status: response?.status ?? null,
          message: response?.message ?? null,
          total_item: response?.total_item ?? null,
          per_page: response?.per_page ?? null,
          total_page: response?.total_page ?? null,
          current_page: response?.current_page ?? null,
        }
      }).catch((error) => {
        if ((error?.response?.data?.detail ?? "") == 'Invalid page.') {
          this.params.page = this.params.page - 1;
        }
        this.metaData = {};
        this.data = [];
      });
      this.$store.state.loading = false;
    },
    async deleteData(id) {
      this.$swal({
        icon: "warning",
        title: "Apakah anda yakin ingin menghapus?",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;
          await UnitKerjaApi.delete(id).then(() => {
            this.getData();
            this.$swal({
              icon: "success",
              title: "Berhasil"
            });
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: "Error",
              text: error?.response?.data?.message ?? "Data tidak dapat dihapus",
            });
          });
          this.$store.state.loading = false;
        }
      })
    }
  },
};
</script>
